import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import "./styles.css";

const styles = () => ({
  rootDialog: {
    zIndex: 1550,
  },
  rootContent: {
    borderRadius: "21px",
    minWidth: "300px",
  },
});

class Turnero extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className="containerTurnero">
        {/* DESCRIPCION PRINCIPAL */}
        <div className="labelDescripcion">
          {this.props.tipo === "pickup"
            ? "Elige el día y la hora en la que el cliente debe retirar el pedido"
            : "Elige el día y la hora de envío del pedido"}
        </div>

        {/* DIAS DISPONIBLES */}
        <div className="containerOptionsDias">
          {this.props.index + 1 > this.props.cantItemShow ? (
            <div
              className="itemArrow"
              onClick={
                this.props.index + 1 > this.props.cantItemShow
                  ? this.props.handleOnClickAnterior
                  : undefined
              }
            >
              <ArrowBackIosIcon className="marginIcon" fontSize="large" />
            </div>
          ) : (
            <div className="itemNotArrow"></div>
          )}

          {this.props.listaFechaHora &&
            this.props.listaFechaHora.length > 0 &&
            this.props.listaFechaHora.map((fh, indice) => {
              if (
                indice >= this.props.index + 1 - this.props.cantItemShow &&
                indice <= this.props.index
              ) {
                return (
                  <div
                    key={fh.idDiaCalendario || indice}
                    className={`itemDia ${this.props.idDiaSelected === fh.idDiaCalendario ? "active" : ""}`}
                    onClick={() => this.props.handleOnClickDia(fh, indice)}
                  >
                    <div
                      className={`diaNumero ${this.props.idDiaSelected === fh.idDiaCalendario ? "activeDiaNumero" : ""}`}
                    >
                      {fh.diaNumero}
                    </div>
                    <div
                      className={`diaNombre ${this.props.idDiaSelected === fh.idDiaCalendario ? "activeDiaNombre" : ""}`}
                    >
                      {fh.diaNombre}
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}

          {
            <div
              className="itemArrow"
              onClick={
                this.props.listaFechaHora &&
                this.props.listaFechaHora.length > 0 &&
                this.props.listaFechaHora.length > this.props.cantItemShow &&
                this.props.index + 1 < this.props.listaFechaHora.length
                  ? this.props.handleOnClickSiguiente
                  : this.props.handleShowMsgTopeDias
              }
            >
              <ArrowForwardIosIcon fontSize="large" />
            </div>
          }
        </div>

        {/* DESCRIPCION LARGA DEL DIA */}
        {this.props.indiceDiaSelected !== undefined &&
          this.props.listaFechaHora &&
          this.props.listaFechaHora.length > 0 &&
          this.props.listaFechaHora[this.props.indiceDiaSelected] !== undefined && (
            <div className="labelDescripcion">
              {this.props.listaFechaHora[this.props.indiceDiaSelected].descripcionLarga}
            </div>
          )}

        {/* HORARIOS DISPONIBLES */}
        <div className="containerOptionsHorarios">
          {this.props.indiceDiaSelected !== undefined &&
            this.props.listaFechaHora &&
            this.props.listaFechaHora.length > 0 &&
            !this.props.listaFechaHora[this.props.indiceDiaSelected].noLaborable &&
            this.props.listaFechaHora[this.props.indiceDiaSelected].horarios !== undefined &&
            // this.props.listaFechaHora[this.props.indiceDiaSelected].horarios.map((h, i) => {
            //     return <div className={`itemHorario ${h.descripcion === 'COMPLETO' ? 'disabled' : ''}`} onClick={h.descripcion === 'COMPLETO' ? undefined : () => this.props.handleOnClickHorario(h, i)}>
            //                 <div className='horario'>{h.descripcion}</div>
            //             </div>
            // })}
            (this.props.listaFechaHora[this.props.indiceDiaSelected].horarios.length === 0 ? (
              // Mostrar alerta si no hay horarios
              <div
                className="itemAlertHorario"
                style={{
                  padding: "12px 16px",
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #2196f3",
                  borderRadius: "4px",
                  color: "#1976d2",
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                <InfoOutlinedIcon
                  style={{
                    marginRight: "8px",
                    fontSize: "20px",
                    color: "#1976d2",
                  }}
                />
                <span>No hay horarios disponibles para este día en la localidad seleccionada.</span>
              </div>
            ) : (
              // Mostrar horarios si los hay
              this.props.listaFechaHora[this.props.indiceDiaSelected].horarios.map((h, i) => {
                return (
                  <div
                    key={`${h.descripcion}-${i}`}
                    className={`itemHorario ${h.descripcion === "COMPLETO" ? "disabled" : ""}`}
                    onClick={
                      h.descripcion === "COMPLETO"
                        ? undefined
                        : () => this.props.handleOnClickHorario(h, i)
                    }
                  >
                    <div className="horario">{h.descripcion}</div>
                  </div>
                );
              })
            ))}

          {this.props.indiceDiaSelected !== undefined &&
            this.props.listaFechaHora &&
            this.props.listaFechaHora.length > 0 &&
            this.props.listaFechaHora[this.props.indiceDiaSelected].noLaborable && (
              <Row>
                <Col>
                  <div className="diaNoLaborable">
                    <InfoOutlinedIcon />
                    <div>
                      {this.props.listaFechaHora[this.props.indiceDiaSelected].mensajeNoLaborable}
                    </div>
                  </div>
                </Col>
              </Row>
            )}
        </div>

        {/* MODAL AVISO DE TOPE DE DIAS */}
        <Dialog
          classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootContent }}
          open={this.props.showModalTopeDias}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent className="">
            <DialogContentText id="alert-dialog-description">
              <div className="textDescripcion">
                Para conservar la calidad del servicio, no ofrecemos turnos de entrega superiores a{" "}
                {this.props.diasAdelante && this.props.diasAdelante > 1
                  ? this.props.diasAdelante + " días."
                  : this.props.diasAdelante + " día."}
              </div>
            </DialogContentText>

            <DialogActions style={{ justifyContent: "center", marginTop: "30px" }}>
              <Button onClick={this.props.handleShowMsgTopeDias} className="btnModalTope" autoFocus>
                ENTENDIDO
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Turnero.defaultProps = {
  tipo: "",
  listaFechaHora: [],
  diasAdelante: "",
  idDiaSelected: undefined,
  indiceDiaSelected: undefined,
  showModalTopeDias: false,
  handleOnClickDia: (f) => f,
  handleOnClickSiguiente: (f) => f,
  handleOnClickAnterior: (f) => f,
  handleOnClickHorario: (f) => f,
  handleShowMsgTopeDias: (f) => f,
};

Turnero.propTypes = {
  listaFechaHora: PropTypes.array.isRequired,
  diasAdelante: PropTypes.number.isRequired,
  idDiaSelected: PropTypes.number.isRequired,
  indiceDiaSelected: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  cantItemShow: PropTypes.number.isRequired,
  tipo: PropTypes.string.isRequired,
  showModalTopeDias: PropTypes.bool.isRequired,
  handleOnClickDia: PropTypes.func.isRequired,
  handleOnClickSiguiente: PropTypes.func.isRequired,
  handleOnClickAnterior: PropTypes.func.isRequired,
  handleOnClickHorario: PropTypes.func.isRequired,
  handleShowMsgTopeDias: PropTypes.func.isRequired,
};

export default withStyles(styles)(Turnero);
